import { AutoLoginForm, AutoLoginLayout } from '@isyc-react/auth/modules/pods/login';
import { useBuCode } from 'common/utils';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
// http://localhost:3010/bailleurs/auto/login?p=TEST&bu=BATIGERE_ASDASD
export const AutologinManager = props => {
    const buCode = useBuCode();
    return (React.createElement(React.Fragment, null,
        React.createElement(BrowserRouter, null,
            React.createElement(AutoLoginLayout, null,
                React.createElement(AutoLoginForm, null)))));
};
